import { c as _c } from "react/compiler-runtime";
import EditTriggerWrapper from 'modules/automation-rules/triggers/components/edit-triggers/components/edit-trigger-wrapper';
import CourseSelect from 'modules/automation-rules/triggers/components/edit-triggers/components/trigger-course-item/components/course-select';
import ModuleSelect from 'modules/automation-rules/triggers/components/edit-triggers/components/trigger-module-item/components/module-select';
import { EditTriggerItemInterface } from 'modules/automation-rules/triggers/components/edit-triggers/types/edit-trigger-item-interface';
import { AutomationRuleTriggersDataEnum } from 'modules/automation-rules/triggers/enums/trigger-enum';
import { TriggerLectureEditInterface } from 'modules/automation-rules/triggers/types/automation-rule-triggers-edit-interface';
import { getDataFromObj } from 'modules/automation-rules/utils/get-filter-data';
import React from 'react';
import { FormSelect, Hint } from 'shared/components';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
interface TriggerLectureItemProps extends EditTriggerItemInterface<TriggerLectureEditInterface> {}
const TriggerLectureItem = t0 => {
  const $ = _c(18);
  const {
    trigger,
    triggers,
    idx,
    errors,
    setRules,
    onDelete,
    isStatic
  } = t0;
  const {
    t
  } = useLocoTranslation();
  let t1;
  if ($[0] !== idx || $[1] !== onDelete) {
    t1 = () => onDelete(idx);
    $[0] = idx;
    $[1] = onDelete;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== errors || $[4] !== idx || $[5] !== isStatic || $[6] !== setRules || $[7] !== t || $[8] !== trigger.course || $[9] !== trigger.id || $[10] !== trigger.lecture || $[11] !== trigger.module || $[12] !== triggers) {
    t2 = t3 => {
      const {
        data,
        renderTriggerLabel,
        onOpen,
        onClear
      } = t3;
      return <><CourseSelect isStatic={isStatic} onChange={data_0 => {
          setRules(prev => ({
            ...prev,
            triggers: triggers.map((el, i) => {
              if (idx === i) {
                return {
                  ...el,
                  course: {
                    id: data_0
                  },
                  module: {
                    id: undefined
                  },
                  lecture: {
                    id: undefined
                  }
                };
              } else {
                return el;
              }
            })
          }));
          onClear(AutomationRuleTriggersDataEnum.module);
          onClear(AutomationRuleTriggersDataEnum.lecture);
        }} triggerId={trigger.id} courseData={data.courseData} courseId={trigger.course.id} course={trigger.course} errors={errors} renderTriggerLabel={renderTriggerLabel} onOpen={onOpen} hint={t("dashboard.automation_rule.trigger.lecture.course_hint")} />{trigger.course.id && <ModuleSelect isStatic={isStatic} triggerId={trigger.id} onOpen={onOpen} module={trigger.module} onChange={data_1 => {
          setRules(prev_0 => ({
            ...prev_0,
            triggers: triggers.map((el_0, i_0) => {
              if (idx === i_0) {
                return {
                  ...el_0,
                  module: {
                    id: data_1
                  },
                  lecture: {
                    id: undefined
                  }
                };
              } else {
                return el_0;
              }
            })
          }));
          onClear(AutomationRuleTriggersDataEnum.lecture);
        }} errors={errors} moduleId={trigger.module?.id} moduleData={data.moduleData} hint={t("dashboard.automation_rule.trigger.lecture.module_hint")} />}{trigger.module?.id && <FormSelect disabled={isStatic} onOpen={() => onOpen(AutomationRuleTriggersDataEnum.lecture)} label={<Hint label={t("dashboard.automation_rule.trigger.lecture.lecture_hint")}>{t("dashboard.course.lecture_title")}</Hint>} placeholder={t("dashboard.automation_rule.trigger.choose_lecture")} value={trigger.lecture?.id} staticData={trigger.lecture && getDataFromObj(trigger.lecture)} data={data.lectureData} onChange={data_2 => setRules(prev_1 => ({
          ...prev_1,
          triggers: triggers.map((el_1, i_1) => {
            if (idx === i_1) {
              return {
                ...el_1,
                lecture: {
                  id: data_2
                }
              };
            } else {
              return el_1;
            }
          })
        }))} error={errors.automationTriggers[trigger.id]?.lecture?.join("")} />}</>;
    };
    $[3] = errors;
    $[4] = idx;
    $[5] = isStatic;
    $[6] = setRules;
    $[7] = t;
    $[8] = trigger.course;
    $[9] = trigger.id;
    $[10] = trigger.lecture;
    $[11] = trigger.module;
    $[12] = triggers;
    $[13] = t2;
  } else {
    t2 = $[13];
  }
  let t3;
  if ($[14] !== t1 || $[15] !== t2 || $[16] !== trigger) {
    t3 = <EditTriggerWrapper trigger={trigger} onDelete={t1}>{t2}</EditTriggerWrapper>;
    $[14] = t1;
    $[15] = t2;
    $[16] = trigger;
    $[17] = t3;
  } else {
    t3 = $[17];
  }
  return t3;
};
export default TriggerLectureItem;